<template>
    <a-layout class="main-wrapper">
        <a-row type="flex" justify="start">
            <a-col class="gutter-row" :span="15" :offset="3">
                <div class="content-wrapper" id="picker-content">
                    <a-skeleton v-if="loading" avatar :paragraph="{rows: 4}" />
                    <a-card v-else style="background-color: #f7f2f2">
                        <a-card-meta :description="signature">
                            <span slot="title">
                                <a-row type="flex" justify="start">
                                    <a-col :span="5">
                                        {{name}}
                                        <a-icon v-if="sex == 1" type="man" :style="{color:'#1E90FF'}" />
                                        <a-icon v-if="sex == 2" type="woman" :style="{color:'#eb2f96'}"/>
                                        <a-popover v-if="mpQrcode" title="公众号二维码："  placement="rightTop">
                                            <template slot="content">
                                                <img :width="150" :height="150" :src="mpQrcode"/>
                                            </template>
                                            <a-icon style="margin-left: 20px;" type="scan"/>
                                        </a-popover>
                                    </a-col>
                                    <a-col :span="5" :offset="14">
                                        <template v-if="! isSelf">
                                            <a-button v-if="subscribe"
                                                      @click="subscribeStatus(false)"
                                                      @mouseover="unsubscribeBtnText='取消'"
                                                      @mouseout="unsubscribeBtnText='已关注'"
                                            >
                                                {{unsubscribeBtnText}}
                                            </a-button>
                                            <a-button v-else @click="subscribeStatus(true)">关注</a-button>
                                            <a-button style="margin-left: 2px" disabled>私信</a-button>
                                        </template>
                                    </a-col>
                                </a-row>
                            </span>
                            <a-avatar slot="avatar" :src="avatar ? avatar : 'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png'" style="width: 100px;height: 100px"/>
                        </a-card-meta>
                        <a-row>
                            <a-col :span="3">
                                关注：<a href="#" @click.prevent.stop="activeTabKey = '4'">{{ interactionData.subscribeCount }}</a>
                            </a-col>
                            <a-col :span="3">
                                粉丝：<a href="#" @click.prevent.stop="activeTabKey = '5'">{{ interactionData.fansCount }}</a>
                            </a-col>
                            <a-col :span="3">
                                文章：<a href="#" @click.prevent.stop="activeTabKey = '1'">{{ interactionData.blogCount }}</a>
                            </a-col>
                            <a-col :span="3">
                                专题：<a href="#" @click.prevent.stop="activeTabKey = '2'">{{ interactionData.topicCount }}</a>
                            </a-col>
                            <a-col :span="3">
                                获赞：{{ interactionData.likedCount }}
                            </a-col>
                        </a-row>
                    </a-card>
                    <div :style="{marginTop:'20px', minHeight:'500px'}">
                        <a-tabs v-model="activeTabKey">
                            <template v-if="activeTabKey <= 5">
                                <a-tab-pane tab="文章" key="1">
                                    <BlogList v-if="authorId" :hide-avatar="true" :author-id="authorId"/>
                                </a-tab-pane>
                                <a-tab-pane tab="专题" key="2">
                                    <TopicPool v-if="authorId" :author-id="authorId"/>
                                </a-tab-pane>
                                <a-tab-pane disabled tab="动态" key="3">Content of Tab Pane 3</a-tab-pane>
                                <a-tab-pane tab="关注" key="4">
                                    <FollowerOrFollowingList v-if="authorId" :author-id="authorId"/>
                                </a-tab-pane>
                                <a-tab-pane tab="粉丝" key="5">
                                    <FollowerOrFollowingList v-if="authorId" :author-id="authorId" :follower="true"/>
                                </a-tab-pane>
                            </template>
                            <template v-if="activeTabKey >= 6 && activeTabKey <= 7">
                                <a-tab-pane :tab="favoriteBlogTab" key="6">
                                    <BlogList v-if="authorId" :hide-avatar="true" :author-id="authorId" :favorite-pool="true"/>
                                </a-tab-pane>
                                <a-tab-pane :tab="favoriteTopicTab" key="7">
                                    <TopicPool v-if="authorId" :author-id="authorId" :favorite-pool="true"/>
                                </a-tab-pane>
                            </template>
                        </a-tabs>
                    </div>
                </div>
            </a-col>
            <a-col class="gutter-row" :span="4">
                <img src="https://picker-oss.oss-cn-beijing.aliyuncs.com/meta/flower.png_target" width="30px" height="30px"/>
                <span style="margin-left: 10px">采采卷耳</span>
                <a-divider/>
                <span style="color: #969696">个人介绍</span>
                <a-icon v-if="isSelf" type="edit" style="margin-left: 10px;cursor: pointer" title="编辑" @click="intro.edit = true"/>
                <pre style="font-size: 16px;margin-top: 10px" v-if="! intro.edit">{{ intro.content && intro.content.length > 0 ? intro.content : '该用户很懒，尚未填写个人简介~' }}</pre>
                <a-spin v-else :spinning="intro.spinning">
                    <a-textarea  :rows="8"  v-model="intro.content" placeholder="个人简介(500 字以内)" @blur="editIntro" autofocus="autofocus">

                    </a-textarea>
                </a-spin>
                <a-divider/>
                <a-row>
                    <span @click="activeTabKey = '7'" style="cursor:pointer">
                       <a-icon style="margin-right: 20px" type="appstore"/> {{sex == 2 ? '她' : '他'}}收藏的专题
                    </span>
                </a-row>
                <a-row>
                    <span @click="activeTabKey = '6'" style="cursor:pointer">
                        <a-icon style="margin-right: 20px; margin-top: 30px" type="star"/> {{sex == 2 ? '她' : '他'}}收藏的文章
                    </span>
                </a-row>
                <a-divider/>
                <span style="color: #969696">社交账号</span>
                <div style="font-size: 18px">
                    <a-row type="flex" justify="start" style="margin-top: 30px">
                        <a-col :span="2">
                            <a-icon style="color: #969696" type="github" @click="github.edit = isSelf"/>
                        </a-col>
                        <a-col :span="22">
                            <template v-if="! github.edit">
                                <a-button v-if="github.url && github.url.length > 0" type="link" @click="open(github.url)">
                                    <em>https://github.com/{{ github.url }}</em>
                                </a-button>
                                <a-button v-else type="link" @click="github.edit = isSelf">{{ isSelf ? '绑定' : '暂无'}}</a-button>
                            </template>
                            <a-spin v-else :spinning="github.spinning">
                                <a-form>
                                    <a-form-item :validateStatus="githubValid ? 'success' : 'warning'">
                                        <a-input addonBefore="github.com/" placeholder="用户名" v-model="github.url" style="margin-left:5px" autofocus="autofocus" @blur="editGithub"/>
                                    </a-form-item>
                                </a-form>
                            </a-spin>
                        </a-col>
                    </a-row>
                </div>
            </a-col>
        </a-row>
    </a-layout>
</template>

<script>
    import BlogList from "@/components/content/blog/BlogList";
    import { AUTHOR_INFO_GET, AUTHOR_SUBSCRIBE_STATUS_GET, AUTHOR_SUBSCRIBE_POST_OR_DELETE, AUTHOR_MP_QRCODE_GET,
        USER_INFO_GET, USER_PROFILE_GET, USER_PROFILE_INTRO_PATCH, USER_PROFILE_GITHUB_PATCH } from "@/components/constant/url_path";
    import { mapGetters } from 'vuex';
    import FollowerOrFollowingList from "@/components/content/user/FollowerOrFollowingList";
    import TopicPool from "./topic/TopicPool";
    export default {
        props:['pickerId'],
        components:{TopicPool, FollowerOrFollowingList, BlogList },
        data() {
            return {
                authorId: undefined,
                unsubscribeBtnText: '已关注',
                loading: true,
                avatar: undefined,
                name: undefined,
                signature: "暂无签名",
                gender: undefined,
                sexColors: ['unset', '#E0FFFF', '#FFE0E3'],
                sex: 0,
                subscribe: false,
                mpQrcode: undefined,
                showQrcode: true,
                interactionData: undefined,
                isSelf: false,
                activeTabKey: "1",
                intro: {
                    content: undefined,
                    edit: false,
                    spinning: false
                },
                github: {
                    url: '',
                    edit: false,
                    spinning: false
                }
            }
        },
        computed: {
            ...mapGetters([
                'isLoggingIn'
            ]),
            backgroundColor() {
                return this.sexColors[this.sex];
            },
            favoriteBlogTab() {
                return this.sex == 2 ? '她收藏的文章' : '他收藏的文章';
            },
            favoriteTopicTab() {
                return this.sex == 2 ? '她收藏的专题' : '他收藏的专题';
            },
            githubValid() {
                if (this.github.url == '') {
                    return true;
                }
                let pattern = /^[a-zA-Z0-9-]+$/;
                return pattern.test(this.github.url);
            }
        },
        created() {
            let _this = this;
            let url = USER_INFO_GET;
            if (_this.pickerId) {
                _this.authorId = _this.pickerId;
                url = AUTHOR_INFO_GET.replace("{pickerId}", _this.authorId);
            }
            if (_this.$route.path == "/main") {
                _this.isSelf = true;
            }
            _this.$axios.get(url)
                .then(function (response) {
                    let code = response.data.code;
                    if (code == 200) {
                        _this.loading = false;
                        _this.avatar = response.data.result.avatar;
                        _this.name = response.data.result.name;
                        _this.gender = response.data.result.sex;
                        _this.signature = response.data.result.signature;
                        _this.sex = response.data.result.sex;
                        _this.interactionData = response.data.result.interactionData;
                        _this.authorId = response.data.result.authorId;
                        _this.$axios.get(AUTHOR_MP_QRCODE_GET.replace("{pickerId}", _this.authorId))
                            .then(function (response) {
                                let code = response.data.code;
                                if (code == 200) {
                                    _this.mpQrcode = response.data.result;
                                }
                            })
                        _this.fetchProfile();
                        if (_this.isLoggingIn) {
                            _this.$axios.get(AUTHOR_SUBSCRIBE_STATUS_GET.replace("{pickerId}", _this.authorId))
                                .then(function (response) {
                                    let code = response.data.code;
                                    if (code == 200) {
                                        _this.subscribe = response.data.result;
                                    }
                                })
                        }
                    }
                })
        },
        methods: {
            subscribeStatus(subscribe) {
                let _this = this;
                if (! _this.isLoggingIn) {
                    _this.$message.info("登录后才可以关注噢~");
                    return;
                }
                if (subscribe) {
                    _this.$axios.post(AUTHOR_SUBSCRIBE_POST_OR_DELETE.replace("{pickerId}", _this.authorId))
                        .then(function (response) {
                            if (response.data.code == 200) {
                                _this.subscribe = true;
                                _this.$message.success("关注成功");
                            } else {
                                _this.$message.info(response.data.message);
                            }
                        })
                        .catch(function () {
                            _this.$message.warn("当前网络不稳定，请稍后重试。");
                        })
                } else {
                    _this.$axios.delete(AUTHOR_SUBSCRIBE_POST_OR_DELETE.replace("{pickerId}", _this.authorId))
                        .then(function (response) {
                            if (response.data.code == 200) {
                                _this.subscribe = false;
                                _this.$message.success("取消关注成功");
                            } else {
                                _this.$message.info(response.data.message);
                            }
                        })
                        .catch(function () {
                            _this.$message.warn("当前网络不稳定，请稍后重试。");
                        })
                }
            },
            fetchProfile() {
                let _this = this;
                _this.$axios.get(USER_PROFILE_GET.replace("{pickerId}", _this.authorId))
                .then(function (response) {
                    let code = response.data.code;
                    if (code == 200) {
                        _this.intro.content = response.data.result.intro;
                        _this.github.url = response.data.result.github;
                    } else {
                        _this.$message.info(response.data.message);
                    }
                }).catch(function () {
                    _this.$message.warn("用户资料加载失败");
                })
            },
            editIntro() {
                let _this = this;
                _this.intro.spinning = true;
                _this.$axios.patch(USER_PROFILE_INTRO_PATCH.replace("{pickerId}", _this.authorId), {
                    intro: _this.intro.content
                }).then(function (response) {
                    _this.intro.spinning = false;
                    if (response.data.code == 200) {
                        _this.intro.edit = false;
                    } else {
                        _this.$message.info(response.data.message);
                    }
                }).catch(function () {
                    _this.intro.spinning = false;
                    _this.$message.warn("系统异常，修改失败。");
                })
            },
            editGithub() {
                let _this = this;
                if (! _this.githubValid) {
                    _this.$message.warning("github 用户名不规范");
                    return;
                }
                _this.github.spinning = true;
                _this.$axios.patch(USER_PROFILE_GITHUB_PATCH.replace("{pickerId}", _this.authorId), {
                    github: _this.github.url
                }).then(function (response) {
                    _this.github.spinning = false;
                    if (response.data.code == 200) {
                        _this.github.edit = false;
                    } else {
                        _this.$message.info(response.data.message);
                    }
                }).catch(function () {
                    _this.github.spinning = false;
                    _this.$message.warn("系统异常，修改失败。");
                })
            },
            open(url) {
                window.open('https://github.com/'.concat(url), '_target');
            }
        }
    }
</script>

<style scoped>
    .main-wrapper {
        padding: 40px 40px 0 0;
        min-height: 80%;
    }
    .content-wrapper {
        padding: 0px 40px 0 40px;
    }
    .ant-card {
        background-color: rgba(247, 242, 242, 0.5) !important;
    }
</style>